// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pIF4","col":"styles_col__egMK3"};